import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { NotificationService } from 'src/app/_services/notification.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { UserService } from 'src/app/_services/user.service';

@Component({
  selector: 'app-confirm-action-dialog',
  templateUrl: './confirm-action-dialog.component.html',
  styleUrls: ['./confirm-action-dialog.component.css']
})
export class ConfirmActionDialogComponent extends UnsubscribeOnDestroy implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmActionDialogComponent>
    ,@Inject(MAT_DIALOG_DATA) public data: any,
     private userService: UserService,
     private token: TokenStorageService,
     private _notificationSvc: NotificationService
  ) {
    super();
  }
  form: FormGroup = new FormGroup( {
  }, {});
  actionGenerada :boolean= false;
  tipo: string = '';
  ngOnInit(): void {
  }
  finish(){  
    this.dialogRef.close({result:'Confirmar'});
  }
  cancel(){
    this.dialogRef.close({result:'Cancelar'});
  }
}
